<template>
    <MatchMedia
        v-slot="{ matches }"
        :query="$options.queries.portable"
    >
        <OffCanvasMenuContent
            v-if="matches"
            :menu-data="menuData"
        />
    </MatchMedia>
</template>

<script>
    import { MatchMedia } from 'vue-component-media-queries';
    import { DEFAULT_MEDIA_DEFINITIONS } from '@constants/breakpoints'
    import OffCanvasMenuContent from './OffCanvasMenuContent';
    import store from '@store/index'

    const queries = DEFAULT_MEDIA_DEFINITIONS
    export default {
        store,
        components: {
            MatchMedia,
            OffCanvasMenuContent
        },
        props: {
            menuData: {
                type: String,
                default: ''
            }
        },
        queries
    }
</script>
